<template>
  <slot v-bind="{ status, copy }" />
</template>

<script>
export default {
  props: ['text'],
  data() {
    return {
      status: 'idle',
    }
  },
  methods: {
    async copy() {
      if (!window.navigator.clipboard) {
        console.error('Clipboard is available on on https')
        return
      }

      try {
        await window.navigator.clipboard.writeText(this.text)
        this.status = 'copied'

        /* Resolved - text copied to clipboard successfully */
      } catch (err) {
        this.status = 'error'
        console.error('Failed to copy: ', err)
        /* Rejected - text failed to copy to the clipboard */
      }

      setTimeout(() => (this.status = 'idle'), 1500)
    },
  },
}
</script>
